import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboardOut20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconClipboardOut20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.75 3c0-.966.784-1.75 1.75-1.75h5c.966 0 1.75.784 1.75 1.75h.25A2.5 2.5 0 0 1 16 5.5V9h-1.5V5.5a1 1 0 0 0-1-1h-.322A1.75 1.75 0 0 1 11.5 5.75h-5A1.75 1.75 0 0 1 4.822 4.5H4.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1H7V17H4.5A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3zm1.75-.25a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h5a.25.25 0 0 0 .25-.25V3a.25.25 0 0 0-.25-.25zm7.44 13.75-5.47-5.47a.75.75 0 1 1 1.06-1.06L15 15.44V12.5a.75.75 0 0 1 1.5 0V18H11a.75.75 0 0 1 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboardOut20);
